var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#002fff",
    stroke: "none",
    d: "M 256 21.333344 C 162.760422 21.338257 82.297501 86.717926 63.210857 177.983063 C 44.12421 269.248169 91.643333 361.39325 177.066666 398.762665 L 238.933334 481.962646 C 242.957687 487.384918 249.311508 490.581787 256.063995 490.581787 C 262.816498 490.581787 269.170319 487.384918 273.194672 481.962646 L 335.06134 398.762665 C 420.506714 361.383606 468.02536 269.20282 448.904083 177.92038 C 429.782867 86.637909 349.263641 21.277618 256 21.333344 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none",
    d: "M 327.53067 218.346649 C 327.53067 257.85199 295.50528 289.877319 256 289.877319 C 216.494705 289.877319 184.469345 257.85199 184.469345 218.346649 C 184.469345 178.84137 216.494705 146.81601 256 146.81601 C 295.50528 146.81601 327.53067 178.84137 327.53067 218.346649 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartPin);
export default __webpack_public_path__ + "static/media/start_pin.4882922734424ee7c0ff5fb95fda18fd.svg";
export { ForwardRef as ReactComponent };